import React from "react";
import Navbar from "react-bootstrap/Navbar";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import { Link } from "react-router-dom";
import { useHistory, useLocation } from "react-router";
import authService from "../../services/auth.service";
import { useApplication, PLATFORM_APPLICATION } from "../../context/ApplicationContext";
import { resolveAssetUrl } from "../../utils/assets";
import { appPath } from "../../utils/appSlug";
import { canAccessDashboard, getReservedAreaPath, getRole, ROLE_LABELS, ROLES } from "../../utils/roles";
import "./index.css"

const BootstrapNavbar = (props) => {
  const { application } = useApplication();
  let location = useLocation();
  let history = useHistory();
  const role = getRole(props.loginStatus);
  const isDashboard = location.pathname.startsWith("/dashboard");
  const isPlatformDashboard =
    isDashboard && (role === ROLES.ADMIN || role === ROLES.SUPERADMIN);
  const brand = isPlatformDashboard ? PLATFORM_APPLICATION : application;
  const isMainSite = !brand?.slug;
  const homePath = isDashboard ? "/dashboard" : (isMainSite ? "/" : appPath(brand.slug));
  const isLoggedIn = Boolean(props.loginStatus['sub']);

  const logout = () => {
    authService.logout();
    props.setLoginStatus({})
    history.push(brand?.slug ? appPath(brand.slug) : "/")
  }

  const reservedAreaPath = getReservedAreaPath(props.loginStatus);
  const showReservedAreaCta = !isMainSite
    ? (!isLoggedIn || canAccessDashboard(props.loginStatus))
    : true;

  const dashboardUserBar = isLoggedIn ? (
    <div className="navbar-dashboard__user">
      <span className="navbar-dashboard__name">
        {(props.loginStatus.fullname || "").trim() || props.loginStatus.sub}
      </span>
      <span className="navbar-dashboard__role">
        {(ROLE_LABELS[getRole(props.loginStatus)] || getRole(props.loginStatus) || "").toUpperCase()}
      </span>
    </div>
  ) : null;

  const populateNavbar = () => {
    if (isDashboard) {
      return (
        <Nav className="ms-auto nav-platform" key="nav-dashboard">
          {dashboardUserBar}
        </Nav>
      );
    }

    if (isMainSite) {
      return (
        <Nav className="ms-auto nav-platform" key="nav-platform">
          <Link
            to="/"
            className={`nav-link navPlatformLink${location.pathname === "/" ? " is-active" : ""}`}
          >
            Home
          </Link>
          <Link
            to="/ottieni"
            className={`nav-link navPlatformLink${location.pathname === "/ottieni" ? " is-active" : ""}`}
          >
            Ottieni
          </Link>
          {showReservedAreaCta && (
            <Link
              to={reservedAreaPath}
              className={`nav-link navPlatformLink navPlatformLink--btn${location.pathname.startsWith("/login") || location.pathname.startsWith("/dashboard") ? " is-active" : ""}`}
            >
              Area Riservata
            </Link>
          )}
        </Nav>
      );
    }

    let elements = [];
    elements.push(
      <Nav className="me-auto" key="nav-left" />
    );
    if (!isLoggedIn) {
      elements.push(
        <Nav key="nav-auth" className="nav-auth">
          <Link
            to={appPath(brand.slug, "login")}
            className={`nav-link navReservedLink${location.pathname.endsWith("/login") ? " is-active" : ""}`}
          >
            Accedi
          </Link>
          <Link
            to={appPath(brand.slug, "register")}
            className={`nav-link navReservedLink${location.pathname.endsWith("/register") ? " is-active" : ""}`}
          >
            Registrati
          </Link>
        </Nav>
      );
    } else {
      elements.push(
        <Nav key="nav-user" className="nav-user">
          {canAccessDashboard(props.loginStatus) ? (
            <Link to="/dashboard" className="nav-link navReservedLink">
              {role === ROLES.GESTORE ? "Gestisci" : "Area riservata"}
            </Link>
          ) : (
            <>
              {dashboardUserBar}
              <button type="button" className="nav-link navReservedLink" onClick={logout}>
                Esci
              </button>
            </>
          )}
        </Nav>
      )
    }

    return elements;
  }

  const NavbarStyle= {
    backgroundColor: brand?.primary_color || "#003274"
    }

  return (
    <Navbar
      style={NavbarStyle}
      expand="lg"
      className={`${isMainSite ? "navbar-platform" : ""}${isDashboard ? " navbar-dashboard" : ""}`.trim()}
    >
      <Container fluid={isDashboard} className={isDashboard ? "navbar-dashboard__inner" : undefined}>
        <Navbar.Brand as={Link} to={homePath} className="navBrand">
          <img
          src={resolveAssetUrl(brand?.logo_url)}
          alt="WebinarPlus"
          className={`d-inline-block align-middle navLogo${isMainSite ? " navLogo--platform" : ""}`}
        />
          {!isMainSite && (
          <div className="navBrandText">
            <span className="navBrandTitle">{brand?.site_title || brand?.name}</span>
            <span className="navBrandSubtitle">{brand?.site_subtitle || ""}</span>
          </div>
          )}
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          {populateNavbar()}
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default BootstrapNavbar;
